import { combineEpics } from 'redux-observable';
import { listSubscriptionsEpic } from './list-subscriptions';
import { loadSubscriptionSummaryAfterLoginEpic } from './load-after-login';
import { loadSubscriptionSummaryAfterSubscribeEpic } from './load-after-subscribe';
import { loadMerchSubscriptionSummaryAfterSubscribeEpic } from './load-after-subscribe-merch';
import { loadSubscriptionSummaryAfterCancelEpic } from './list-after-cancel-subscription';
import { subscriptionGuardEpic } from './subscription-guard';
import { hideUpgradeIfSubscribedEpic } from './hide-upgrade-if-subscribed';
import { loadSubscriptionSummaryAfterArtistActiveEpic } from './load-after-active';

const subscriptionManagerEpic = combineEpics(
  listSubscriptionsEpic,
  loadSubscriptionSummaryAfterLoginEpic,
  loadSubscriptionSummaryAfterSubscribeEpic,
  loadSubscriptionSummaryAfterArtistActiveEpic,
  loadMerchSubscriptionSummaryAfterSubscribeEpic,
  loadSubscriptionSummaryAfterCancelEpic,
  subscriptionGuardEpic,
  hideUpgradeIfSubscribedEpic
);

export default subscriptionManagerEpic;
